import React from 'react'
import Logo from './Logo'
import Product from './Product'

const Index = (props) => (<Logo {...props}/>)
Index.Product = Product

export default Index